<template>
  <div id="pers-tab2" name="hres31x-tab2" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">

    <!--Start Topic #1-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC1']['290'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['30'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codblood'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['40'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['v_weight'] }} {{ constLabels[nowLang].kilogram }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['50'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['v_high'] }} {{ constLabels[nowLang].centimater }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['60'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codrelgn'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['80'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codorgin'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['90'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codnatnl'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['190'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteempdb']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['70'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['coddomcl'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['200'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['stamarry'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['210'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['stamilit'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['100'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numappl'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['150'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numprmid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['160'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteprmst']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['170'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteprmen']) }}</div>
      </div>
    </div>
    <!--End Topic #1-->
    <!--Start Topic #2-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic2">
      <i class="fa fa-id-card-o icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC2']['220'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic2">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['230'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numoffid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['240'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['adrissue'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['250'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codprovi'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['260'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteoffid']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['130'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numpasid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['140'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dtepasid']) }}</div>
      </div>
    </div>
    <!--End Topic #2-->
    <!--Start Topic #3-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic3">
      <i class="fa fa-id-card-o icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ constLabels[nowLang].driverC }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic3">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['110'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numlicid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['120'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dtelicid']) }}</div>
      </div>
    </div>
    <!--End Topic #3-->
    <!--Start Topic #4-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic4">
      <i class="fa fa-home icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC2']['270'] }}{{ labels['HRES31XC2']['280'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic4">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['280'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['adrregt'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['290'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['dessubdistr'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['300'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desdistr'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['310'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desprovr'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['320'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['descntyr'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['330'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codpostr'] }}</div>
      </div>
    </div>
    <!--End Topic #4-->
    <!--Start Topic #5-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic5">
      <i class="fa fa-home icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC2']['340'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic5">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['340'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['adrconte'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['350'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['dessubdistc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['360'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desdistc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['370'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desprovc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['380'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['descntyc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['390'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codpostc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC2']['400'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numtelec'] }}</div>
      </div>
    </div>
    <!--End Topic #5-->
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres31x-tab2',
  data () {
    return {
      constLabels: {
        en: {
          driverC: 'driver license',
          centimater: 'cm',
          kilogram: 'kg'
        },
        th: {
          driverC: 'ใบอนุญาตขับขี่',
          centimater: 'ซม.',
          kilogram: 'กก.'
        }
      },
      subTopic1: true,
      subTopic2: true,
      subTopic3: true,
      subTopic4: true,
      subTopic5: true
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    },
    toggleSubTopic4 () {
      this.subTopic4 = !this.subTopic4
    },
    toggleSubTopic5 () {
      this.subTopic5 = !this.subTopic5
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}

</script>


// WEBPACK FOOTER //
// tab2.vue?24961f62